// Copyright (c) 2018 Deere & Company

import {Component} from 'react';

function handlePaste(event) {

    /* eslint-disable  no-underscore-dangle */

    const dispatchValue = () => {

        const eventToDispatch = {
            target: {
                value: event.target.value
            }
        };

        const reactInstance = Object.keys(event.target).find(key => key.match('_reactInternalInstance'));

        event.target[reactInstance]._currentElement.props.onChange(eventToDispatch);

    };

    setTimeout(dispatchValue, 20);

}

class IEPasteFix extends Component {

    componentWillMount() {

        if (window.clipboardData) {

            document.addEventListener('paste', this.props::handlePaste);

        }

    }

    render = () => null

}

IEPasteFix.displayName = 'IEPasteFix';

export default IEPasteFix;



// WEBPACK FOOTER //
// ./src/app/ie-paste-fix.js